<template>
    <div>

    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    created() {
        let path=this.$getUrlKey("path");
        this.$getInteboQyWechatLogin(path);
    }
}
</script>


// WEBPACK FOOTER //
// src/page/intebo/inteboQyWechatLoginNew.vue